import { ExternalLink, SectionHeading } from '@atlassian/mpac-ui';
import * as React from 'react';
import Section from "../../../../Section";
import { ResourceItem } from "../styles";
import { SupportResourcesLink } from "../types";

var SupportResources = function SupportResources(props) {
  var _props$supportDetails = props.supportDetails,
      resources = _props$supportDetails.resources,
      isAtlassianCommunityEnabled = _props$supportDetails.isAtlassianCommunityEnabled,
      communityQuestionLink = props.communityQuestionLink;

  var atlassianCommunityResource = function atlassianCommunityResource() {
    if (!isAtlassianCommunityEnabled) return null;
    var linkText = communityQuestionLink.type === 'existing' ? 'See existing Q&A in Atlassian Community' : 'Ask a question in the Atlassian Community';
    return /*#__PURE__*/React.createElement(ResourceItem, null, /*#__PURE__*/React.createElement(ExternalLink, {
      href: communityQuestionLink.url,
      onClick: function onClick() {
        return props.onSupportLinkClick(SupportResourcesLink.ATLASSIAN_COMMUNITY);
      }
    }, linkText), /*#__PURE__*/React.createElement("p", null, "Atlassian-hosted discussions connect you to other customers who use this app."));
  };

  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SectionHeading, null, "Vendor support resources"), resources.documentationUrl && /*#__PURE__*/React.createElement(ResourceItem, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: resources.documentationUrl,
    onClick: function onClick() {
      return props.onSupportLinkClick(SupportResourcesLink.DOCUMENTATION);
    },
    title: "Documentation"
  }, "Documentation"), /*#__PURE__*/React.createElement("p", null, "Find out how this app works")), resources.wikiUrl && /*#__PURE__*/React.createElement(ResourceItem, null, /*#__PURE__*/React.createElement(ExternalLink, {
    href: resources.wikiUrl,
    onClick: function onClick() {
      return props.onSupportLinkClick(SupportResourcesLink.WIKI);
    },
    title: "Wiki"
  }, "Wiki"), /*#__PURE__*/React.createElement("p", null, "Collaborative documentation platform hosted by this vendor.")), resources.forumsUrl && /*#__PURE__*/React.createElement(ResourceItem, null, /*#__PURE__*/React.createElement(ExternalLink, {
    onClick: function onClick() {
      return props.onSupportLinkClick(SupportResourcesLink.COMMUNITY);
    },
    href: resources.forumsUrl,
    title: "Community"
  }, "Community"), /*#__PURE__*/React.createElement("p", null, "Community discussions connect you to the vendor and other customers who use this app.")), atlassianCommunityResource());
};

export default SupportResources;